import { render, staticRenderFns } from "./IconSectionFooter.vue?vue&type=template&id=f67318ec&"
import script from "./IconSectionFooter.vue?vue&type=script&lang=js&"
export * from "./IconSectionFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f67318ec')) {
      api.createRecord('f67318ec', component.options)
    } else {
      api.reload('f67318ec', component.options)
    }
    module.hot.accept("./IconSectionFooter.vue?vue&type=template&id=f67318ec&", function () {
      api.rerender('f67318ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSectionFooter.vue"
export default component.exports